export const TOOL_ROUTING_SEARCH_TOOL_NAME = "searchTools";
export const TOOL_ROUTING_CALL_TOOL_NAME = "callTool";
export const TOOL_ROUTING_INTERNAL_TOOL_SYMBOL = Symbol("voltagent.toolRoutingInternal");
